module.exports = __webpack_public_path__ + "img/Novaes.36604a6d.jpeg";